import React from "react";
import SidebarBlog from "../components/blog/sidebar-blog";
import BlogCreate from "../components/blog/blog-create";
import Layout from "../components/layout/layout";

const BlogCreatePage = () => {
  return (
    <>
      <Layout>
        <div class="content">
          <div class="container">
            <div class="row">
              <BlogCreate />
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default BlogCreatePage;
